import React from 'react';

import {Layout} from '../../components/layout';
import {useRoute} from '../../lib/routes';
import {SectionSeo} from '../../lib/seo';
import {MapGrid} from './map-grid';
import {MapView} from './map-view';

import css from './maps-page.module.css';

const MapsIndex: React.FC = () => (
	<div className={css.page}>
		<SectionSeo section="maps" headingClassName={css.title} />
		<MapGrid />
	</div>
);

export const MapsPage: React.FC = () => {
	const {routeName, params} = useRoute();

	return <Layout>{routeName === 'map' ? <MapView id={params.id} /> : <MapsIndex />}</Layout>;
};
